import { Theme } from '@mui/material/styles';

export const getStyles = (theme: Theme) => ({
  errorContainer: {
    p: 3,
  },
  mainContainer: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.spacing(0.625),
    overflow: 'hidden',
    marginBottom: theme.spacing(2),
  },
  sectionDivider: {
    marginX: theme.spacing(3),
    marginY: theme.spacing(2),
    borderColor: theme.palette.grey[300],
  },
  // "Open for changes until … | Covers N days" subtitle row under the title.
  daysCoveredRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
  },
  daysCoveredItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  daysCoveredText: {
    marginLeft: theme.spacing(0.5),
    fontSize: 13,
    fontWeight: 400,
    color: theme.palette.text.secondary,
  },
  daysCoveredSeparator: {
    marginX: theme.spacing(1),
    fontSize: 13,
    color: theme.palette.text.secondary,
  },
  // eva-icons render the glyph in an inline-block wrapper with descender
  // whitespace, floating it above the text; block display centers it.
  daysCoveredIcon: {
    '& svg': { display: 'block' },
  },
  dialogPaper: {
    borderRadius: theme.spacing(1),
    maxHeight: '90vh',
  },
});
